import {withEntities} from '@ngneat/elf-entities';
import {withPagination} from '@ngneat/elf-pagination';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {createStore} from '@ngneat/elf';
import {InvoicingPeriod} from '@store/settings/invoicingPeriod/invoicing-period.model';

export const invoicingPeriodStore = createStore(
  { name: 'invoicing-period' },
  withEntities<InvoicingPeriod>(),
  withPagination(),
  withRequestsStatus(),
);
